import React from 'react';
import { useClipboard } from '@jwp/ott-hooks-react/useClipboard';

import styles from './SharePopover.module.scss';

interface SharePopoverProps {
  isVisible: boolean;
  currentURL: string;
  onClose: () => void;
}
export const SharePopover: React.FC<SharePopoverProps> = ({ isVisible, currentURL, onClose }) => {
  const { copied, copyToClipboard } = useClipboard();

  if (!isVisible) return null;

  return (
    <div className={styles.sharePopover}>
      <div className={styles.sharePopoverContent}>
        <div className={styles.sharePopoverHeader}>
          <h3>Share this insight</h3>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close share popover">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        <div className={styles.urlContainer}>
          <input type="text" value={currentURL} readOnly className={styles.urlInput} />
          <button className={styles.copyButton} onClick={() => copyToClipboard(currentURL)} aria-label="Copy link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={20}
              height={20}
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="7" y="7" width="11" height="11" rx="2" ry="2" />
              <path d="M4 12H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v1" />
            </svg>
            Copy
          </button>
        </div>
        {copied && <span className={styles.copiedText}>Copied Successfully!</span>}
      </div>
    </div>
  );
};
